<template>
  <div class="login-index-content">
    <div v-if="modalIntroBrand === 'ELITE'" class="wd-pt-4">
      <v-img class="wd-mx-auto wd-mb-3" max-width="120" cover src="@/assets/images/logo/logo_elite.svg?url" />
      <p class="mb-3" style="text-align: center">
        {{ $t('elite_login_description') }}
      </p>
    </div>
    <div class="wd-pt-7">
      <v-btn class="login-index__btn mb-3" color="purple50" :loading="fbLoginLoading" variant="flat" width="100%" :height="40" @click="fbLogin">
        {{ $t('login_fb') }}
      </v-btn>
      <v-btn class="login-index__btn mb-3" color="orange50" :loading="loginLoading" variant="flat" width="100%" :height="40" @click="createAccount">
        {{ $t('create_account') }}
      </v-btn>
      <v-btn
        class="login-index__btn login-btn--default mb-3"
        color="balck50"
        :loading="loginLoading"
        variant="outlined"
        width="100%"
        :height="40"
        @click="login"
      >
        {{ $t('all_login') }}
      </v-btn>
    </div>

    <div :class="modalIntroBrand ? 'wd-mt-12' : 'wd-mt-38'">
      <v-btn v-if="!isFunBookV2" class="wd-mb-2 wd-text-orange50 wd-text-otempsm" variant="flat" width="100%" :height="24" @click="handleOpen">
        {{ $t('login_page_contact_us') }}
      </v-btn>
      <div class="login-index__footer" v-html="$t('claim_term')" />
    </div>
  </div>
</template>

<script>
import { windowDetector } from '@/utils/utils'
import { useFBLogin } from '@/composition/useLogin'
import { oauthStateSeeds } from '@/view-models/account'

import { usePlatformStore } from '@/store-pinia/platform'

export default defineComponent({
  name: 'FunNowLoginIndex',
  components: {},
  props: {
    modalIntroBrand: { type: String, default: '' },
  },
  emits: ['changeAuthStep', 'success', 'showConsentStep'],
  setup(props, { emit }) {
    const { isFunBookV2 } = storeToRefs(usePlatformStore())
    const { handleOpen } = useCustomerService()
    const { login: fbDialogLogin, showConsent, handleConsentConfirm: fbHandleConsentConfirm } = useFBLogin()

    // Watch for showConsent changes and emit to parent
    watch(showConsent, shouldShow => {
      if (shouldShow) {
        emit('showConsentStep', userContract => {
          return fbHandleConsentConfirm(userContract)
        })
      }
    })

    return {
      isFunBookV2,
      handleOpen,
      fbDialogLogin,
    }
  },
  data() {
    return {
      loginLoading: false,
      fbLoginLoading: false,
      errorMessage: '',
    }
  },
  methods: {
    clearError() {
      this.errorMessage = ''
    },
    getRandomString(stringLength) {
      let randomString = ''
      for (let index = 0; index < stringLength; index++) {
        const element = oauthStateSeeds[Math.floor(Math.random() * oauthStateSeeds.length)]
        randomString = randomString.concat(element)
      }

      return randomString
    },
    async fbLogin() {
      if (windowDetector.isInAppBrowser) {
        this.oauthFacebookLogin()
        return
      }
      const isLogin = await this.fbDialogLogin()
      if (!isLogin) {
        return
      }
      this.$emit('success')
    },
    oauthFacebookLogin() {
      this.fbLoginLoading = true

      const state = this.getRandomString(10)
      this.$cookiz.set('fbLoginStateParam', state, { path: '/', maxAge: 300 })

      this.$cookiz.set('RedirectTo', window.location.href, { path: '/', maxAge: 60 })
      const fbLoginUrl = `https://www.facebook.com/dialog/oauth?client_id=${this.$config.public.FB_APP_ID}&redirect_uri=${window.location.origin}/auth/fb-login&state=${state}&scope=email`
      location.href = fbLoginUrl
    },
    createAccount() {
      this.$emit('changeAuthStep', 'sign-up')
    },
    login() {
      this.$emit('changeAuthStep', 'login')
    },
  },
})
</script>

<style scoped lang="scss">
.login-index-content {
  .login-index {
    &__btn {
      font-size: 17px;
      &.login-btn--default {
        border-color: $gray50 !important;
      }
    }

    &__footer {
      font-size: 13px;
    }
  }
}
</style>
